/**
 * Icons — wrapper nad lucide-react z mapowaniem nazw używanych w obecnej apce
 * (Material Symbols → lucide). Centralne miejsce żeby przy zmianie zestawu ikon
 * nie trzeba było zmieniać 50+ importów.
 */
import {
  // Core nav
  LayoutDashboard,
  BarChart3,
  Target,
  User,
  Settings,
  Wallet,
  // Actions
  Plus,
  Minus,
  Check,
  X,
  Pencil,
  Trash2,
  Search,
  Copy,
  Filter,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  ArrowDownLeft,
  ArrowLeftRight,
  // Money
  Banknote,
  TrendingUp,
  TrendingDown,
  PiggyBank,
  Receipt,
  CreditCard,
  // Status
  AlertCircle,
  AlertTriangle,
  Info,
  CheckCircle2,
  XCircle,
  // Auth & security
  Shield,
  Lock,
  Eye,
  EyeOff,
  LogOut,
  LogIn,
  Mail,
  // Misc
  Calendar,
  Clock,
  Bell,
  Heart,
  Star,
  Award,
  Flame,
  Gem,
  Sun,
  Moon,
  RefreshCw,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Home,
  Users,
  Sparkles,
  // Categories (mapowanie z Material Symbols nazw używanych w obecnej apce)
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  UtensilsCrossed,
  Car,
  Stethoscope,
  HeartPulse,
  Coins,
  Gift,
  Plane,
  GraduationCap,
  Dumbbell,
  Film,
  Music,
  PawPrint,
  Baby,
  Briefcase,
  Building2,
  Phone,
  Wifi,
  Zap,
  Droplet,
  Trees,
  Landmark,
  ChartPie,
  Repeat,
  Pause,
  Play,
} from 'lucide-react';

export const Icons = {
  // Nav
  Dashboard: LayoutDashboard,
  Analytics: BarChart3,
  Goals: Target,
  Profile: User,
  Settings,
  Wallet,
  // Actions
  Plus,
  Minus,
  Check,
  X,
  Edit: Pencil,
  Trash: Trash2,
  Search,
  Copy,
  Filter,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  ArrowDownLeft,
  Transfer: ArrowLeftRight,
  // Money
  Banknote,
  TrendingUp,
  TrendingDown,
  PiggyBank,
  Receipt,
  CreditCard,
  Coins,
  // Status
  Alert: AlertTriangle,
  AlertCircle,
  Info,
  Success: CheckCircle2,
  Error: XCircle,
  // Auth
  Shield,
  Lock,
  Eye,
  EyeOff,
  LogOut,
  LogIn,
  Mail,
  // Misc
  Calendar,
  Clock,
  Bell,
  Heart,
  Star,
  Award,
  Flame,
  Gem,
  Sun,
  Moon,
  Refresh: RefreshCw,
  MoreH: MoreHorizontal,
  MoreV: MoreVertical,
  Menu,
  Home,
  Users,
  Sparkles,
  ChartPie,
  // Categories
  Food: ShoppingBasket,
  Shopping: ShoppingBag,
  Cart: ShoppingCart,
  Restaurant: UtensilsCrossed,
  Car,
  Health: Stethoscope,
  HeartPulse,
  Gift,
  Travel: Plane,
  Education: GraduationCap,
  Sport: Dumbbell,
  Movie: Film,
  Music,
  Pets: PawPrint,
  Child: Baby,
  Work: Briefcase,
  Building: Building2,
  Phone,
  Wifi,
  Bills: Zap,
  Droplet,
  Nature: Trees,
  Bank: Landmark,
  Repeat,
  Pause,
  Play,
};

export type IconName = keyof typeof Icons;
